import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../data-services/index';
import { IUser, IContactExists, ILogin } from '@ebb-v2/ebb-integration';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { take, map } from 'rxjs/operators';

export interface IUserApp {
  userId: string;
  appId: string;
}

@Component({
  selector: 'ebb-portal-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public loginLegacyForm: FormGroup;
  public loginError: 'none' | 'no b2c but verified' | 'not verified' | 'no account' | 'not able to verify' | 'not able to forget password';
  public authenticationError: boolean;
  public legacyConversion = false;
  public legacyConvertSuccess = false;
  public legacyForgotSuccess = false;
  public debarred = false;
  public loginRedirectCount:number;
  public loginRedirectCountdown$: Observable<number>;

  constructor(
    private apiAuthentication: AuthenticationService,
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {

    this.loginForm = this._fb.group({
      email: [null,
        [
          Validators.required,
          Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
          Validators.maxLength(100)
        ]
      ]
    });

    this.loginLegacyForm = this._fb.group({
      email: [{value:'',disabled:true}],
      password: [null,
        [
          Validators.required,
          Validators.maxLength(100)
        ]
      ]
    });

    //already authenticated - redirect
    this.route
      .queryParams
      .subscribe(params => {
        // console.log(params['error']);
        this.authenticationError = params['error'] === 'true' || false;
        // console.log(params['error'], this.authenticationError);

        this.apiAuthentication.getCurrentAuthentication().subscribe(user => {
          if(user && user.isAdmin && !user.email){
            this.router.navigate(['impersonation']);
          }
          if(user && user.isVerified && !this.authenticationError){
            this.router.navigate(['authorization']);
          }
        });
      });
  }

  public logInUser() {
    const email = this.loginForm.get('email').value;
    this.loginError = 'none';
    this.debarred = false;

    this.apiAuthentication.getUserStatus(email).subscribe((data) => {
      const user = data as IContactExists;
      if(user && user.hasB2c && !user.isDebar){
        //email is verified but not auth
        this.loginPageRedirect(email);
      } else if(user && user.isDebar) {
          //has been debarred
          this.debarred = true;
      } else if(user && user.isEbbLegacy) {
        //legacy needs update
        this.legacyConversion = true;
        this.loginLegacyForm.get('email').setValue(email);
      } else if(user && user.isVerified && !user.hasB2c) {
        //no b2c account but verified
        this.loginError = 'no b2c but verified';
        this.legacyForgotPassword();
      } else if(user && user.isVerified === false && !user.hasB2c) {
        //no b2c account and not verified
        this.loginError = 'not verified';
      } else {
        //no account
        this.loginError = 'no account';
      }
    });
  }

  public activateAccount(event) {
    event.preventDefault();
    const email = this.loginForm.get('email').value;
    const login: ILogin = {
      email: email,
      firstName: 'account',
      lastName: 'validate',
      zipcode: ''
    }
    this.apiAuthentication.loginGuest(login, '/activate').subscribe();
  }

  public cancelLegacylogInUser() {
    this.legacyConversion = false;
    this.legacyConvertSuccess = false;
    this.loginError = 'none';
  }

  public legacyLogInUser() {
    const email = this.loginForm.get('email').value;
    const password = this.loginLegacyForm.get('password').value;
    this.apiAuthentication.convertLegacyEbb(email, password).subscribe( result => {
      if(result && result.toLowerCase() === 'success'){
        this.legacyConvertSuccess = true;
        this.loginRedirectCount = 5;
        this.loginRedirectCountdown$ = timer(0,1000).pipe(
          take(this.loginRedirectCount),
          map(() => --this.loginRedirectCount)
        )
        this.loginRedirectCountdown$.subscribe(x => {
          if(this.loginRedirectCount <= 0){
            this.loginPageRedirect(email);
          }
        });
        this.loginError = 'none';
      } else {
        //not able to convert
        this.legacyConvertSuccess = false;
        this.loginError = 'not able to verify';
      }
    });
  }

  public legacyForgotPassword(){
    const email = this.loginForm.get('email').value;

    this.apiAuthentication.convertLegacyForgotPasswordEbb(email).subscribe( result => {
      if(result && result.toLowerCase() === 'success'){
        this.legacyForgotSuccess = true;
        this.loginRedirectCount = 10;
        this.loginRedirectCountdown$ = timer(0,1000).pipe(
          take(this.loginRedirectCount),
          map(() => --this.loginRedirectCount)
        )
        this.loginRedirectCountdown$.subscribe(x => {
          if(this.loginRedirectCount <= 0){
            this.forgotPasswordPageRedirect(email);
          }
        });
        //this.loginError = 'none';
      } else {
        //not able to convert
        this.legacyConvertSuccess = false;
        this.loginError = 'not able to forget password';
      }
    });
  }

  public loginPageRedirect(email:string){
    const b2cUrl = this.apiAuthentication.loginUser(email);
    window.location.href = b2cUrl;
  }

  public forgotPasswordPageRedirect(email:string){
    const b2cUrl = this.apiAuthentication.forgotPasswordRedirectUser(email);
    window.location.href = b2cUrl;
  }

}
